import React from "react";
import { View, Text, StyleSheet } from "@react-pdf/renderer";

const tableStyles = StyleSheet.create({
	tableContainer: {
		width: "100%",
		marginVertical: 10,
	},
	tableTitle: {
		fontSize: 14,
		textAlign: "justify",
		color: "#212B36",
		fontFamily: "Times-Bold",
		marginBottom: 5,
	},
	tableRow: {
		flexDirection: "row",
		borderBottomWidth: 1,
		borderBottomColor: "#bfbfbf",
		borderBottomStyle: "solid",
		alignItems: "stretch",
		minHeight: 20,
		borderLeftWidth: 1,
		borderLeftColor: "#bfbfbf",
		borderLeftStyle: "solid",
		borderRightWidth: 1,
		borderRightColor: "#bfbfbf",
		borderRightStyle: "solid",
	},
	headerRow: {
		backgroundColor: "#122149",
		borderTopWidth: 1,
		borderTopColor: "#bfbfbf",
		borderTopStyle: "solid",
	},
	oddRowBackground: {
		backgroundColor: "#edf1fa",
	},
	tableCellView: {
		padding: 4,
		borderRightWidth: 1,
		borderRightColor: "#d8d8d8",
		borderRightStyle: "solid",
		justifyContent: "center",
	},
	lastCell: {
		borderRightWidth: 0,
	},
	tableCellText: {
		fontSize: 8,
		textAlign: "left",
		fontFamily: "Times-Roman",
	},
	headerCellText: {
		fontSize: 10,
		fontWeight: "bold",
		textAlign: "left",
		color: "#fff",
		fontFamily: "Times-Bold",
	},
});

export const PdfTable = ({ title, columns, data }) => {
	if (!data || data.length === 0) return null;

	return (
		<View style={tableStyles.tableContainer}>
			{title && <Text style={tableStyles.tableTitle}>{title}</Text>}

			<View style={[tableStyles.tableRow, tableStyles.headerRow]} fixed>
				{columns.map((col, index) => (
					<View
						key={index}
						style={[
							tableStyles.tableCellView,
							{ width: col.width },
							index === columns.length - 1 ? tableStyles.lastCell : {},
						]}
					>
						<Text style={tableStyles.headerCellText}>{col.header}</Text>
					</View>
				))}
			</View>

			{data.map((row, rowIndex) => {
				const rowStyles = [tableStyles.tableRow];
				if (rowIndex % 2 === 0) rowStyles.push(tableStyles.oddRowBackground);

				return (
					<View style={rowStyles} key={rowIndex} wrap={false}>
						{columns.map((col, colIndex) => (
							<View
								key={colIndex}
								style={[
									tableStyles.tableCellView,
									{ width: col.width },
									colIndex === columns.length - 1 ? tableStyles.lastCell : {},
								]}
							>
								<Text style={tableStyles.tableCellText}>
									{col.render ? col.render(row) : row[col.dataKey]}
								</Text>
							</View>
						))}
					</View>
				);
			})}
		</View>
	);
};
